import { useEffect, useState, VFC } from 'react'
import { MemberPageWrapper } from 'src/components/PageWrapper'
import { Advertisement } from 'src/models/Advertisement'
import { Article, ModalArticle } from 'src/models/Article'
import { Event } from 'src/models/Event'
import { TimelineType } from 'src/models/Timeline'
import { LoginUser, NewUser } from 'src/models/User'
import { _membertopbg } from 'src/styles/colors'
import { TOP } from 'src/utils/routes'
import styled from 'styled-components'
import { Advertisements } from './Advertisements'
import { Articles } from './Articles'
import { MyPageEvents } from './MyPageEvents'
import { OnlyStoryGuide } from './OnlyStoryGuide'
import { popUpAvailable, PopUpModal, PopUpType } from './PopUp'
import { ModalArticleModal } from './PopUp/ModalArticle'
import { Timeline } from './Timeline'

type MyPageLayoutProps = MyPageContentProps
export const MyPageLayout: VFC<MyPageLayoutProps> = (props) => {
  const { user, popUp, articles, modalArticle } = props
  const [popUpOpen, setPopUpOpen] = useState(!!popUp)
  const [modalArticleOpen, setModalArticleOpen] = useState(
    !!modalArticle?.modal,
  )

  useEffect(() => {
    setModalArticleOpen(!!modalArticle?.modal)
    setPopUpOpen(!!popUp)
  }, [popUp, modalArticle])

  return (
    <>
      <MyPageWrapper
        user={user}
        currentPath="マイページ"
        parentPaths={[{ label: 'Home', path: TOP }]}
        shouldDisplayBanner={false} // NOTE: Topページのバナーの表示有無
      >
        <MyPageContent {...props} />
      </MyPageWrapper>
      {popUpAvailable(popUp) && popUpOpen && (
        <PopUpModal
          popUp={popUp}
          latestArticle={articles[0]}
          close={() => setPopUpOpen(false)}
        />
      )}
      {modalArticleOpen && modalArticle && !popUpOpen && (
        <ModalArticleModal
          id={modalArticle.id}
          title={modalArticle.title}
          image={modalArticle.image}
          content={modalArticle.content.replace(/\n/g, '<br />')}
          linkPath={modalArticle.linkPath}
          appPath={modalArticle.appPath}
          modal={modalArticle.modal}
          close={() => setModalArticleOpen(false)}
        />
      )}
    </>
  )
}

type MyPageContentProps = {
  user: LoginUser
  newUsers?: NewUser[]
  articles: Article[]
  popUp?: PopUpType | null
  modalArticle?: ModalArticle
  timeline: TimelineType[]
  mutateTimeline: () => void
  advertisements: Advertisement[]
  events: Event[]
}
const MyPageContent: VFC<MyPageContentProps> = ({
  user,
  articles,
  timeline,
  mutateTimeline,
  advertisements,
  events,
}) => {
  if (!user.id) return <></>

  const hasPaid = user?.plan.paid || false
  return (
    <>
      <OnlyStoryGuide hasPaid={hasPaid} />
      {advertisements.length > 0 && (
        <Advertisements advertisements={advertisements} />
      )}
      {events.length > 0 && <MyPageEvents events={events} />}
      {timeline.length > 0 && (
        <Timeline
          timeline={timeline}
          mutateTimeline={mutateTimeline}
          hasPaid={hasPaid}
          user={user}
        />
      )}
      {articles.length > 0 && <Articles articles={articles} />}
    </>
  )
}
const MyPageWrapper = styled(MemberPageWrapper)`
  background-color: ${_membertopbg};
`
